
const USB = () => {
	return (
		<>
			<rect x="10" y="30" width="70" height="80" rx="10" className="secondary" />
			<polyline
				stroke="black"
				strokeWidth="2"
				fill="none"
				points="100,40 45,40 45,90 50,90 40,90"
			/>
			<circle
				stroke="black"
				strokeWidth="2"
				className="secondary"
				cx="45"
				cy="70"
				r="10"
			/>
			<polyline
				stroke="black"
				strokeWidth="2"
				fill="none"
				points="52,68 45,60 38,68"
			/>
		</>
	)
}

const SOL = () => {
	return (
		<>
			<polyline
				stroke="black"
				strokeWidth="2"
				fill="none"
				points="100,205 60,205 60,300 50,300 70,300 60,300 60,205 20,205 20,230 10,230 30,230"
			/>
			<polyline
				stroke="black"
				strokeWidth="2"
				fill="none"
				points="100,400, 60,400 60,430 50,430 70,430 60,430 60,305 50,305 70,305"
			/>
			<text className="static" x="65" y="320">C<tspan dy="2" fontSize="0.7em">HRV</tspan></text>
			<text className="static" x="55" y="200">V<tspan dy="2" fontSize="0.7em">SOL</tspan></text>
		</>
	)
}

const CLTS = () => {
	return (
		<>
			<polyline
				stroke="black"
				strokeWidth="3"
				fill="none"
				points="310,600, 310,620 325,620 295,620"
			/>
			<polyline
				stroke="black"
				strokeWidth="3"
				fill="none"
				points="320,625, 300,625 310,625 310,640 305,640 315,640"
			/>
			<text className="static" x="320" y="638">C<tspan dy="2" fontSize="0.7em">LTS</tspan></text>
		</>
	)
}

const CSTS = () => {
	return (
		<>
			<polyline
				stroke="black"
				strokeWidth="3"
				fill="none"
				points="370,600, 370,620 360,620 380,620"
			/>
			<polyline
				stroke="black"
				strokeWidth="3"
				fill="none"
				points="360,625, 380,625 370,625 370,640 375,640 365,640"
			/>
			<text className="static" x="380" y="638">C<tspan dy="2" fontSize="0.7em">STS</tspan></text>
		</>
	)
}

const VSS1 = () => {
	return (
		<polyline
			stroke="black"
			strokeWidth="3"
			fill="none"
			points="660,600, 660,620 670,620 650,620"
		/>
	)
}

const CREG = () => {
	return (
		<>
			<polyline
				stroke="black"
				strokeWidth="3"
				fill="none"
				points="900,35 960,35 960,55 970,55 950,55"
			/>
			<polyline
				stroke="black"
				strokeWidth="3"
				fill="none"
				points="950,60 970,60 960,60 960,80 955,80 965,80"
			/>
			<text className="static" x="970" y="75">C<tspan dy="2" fontSize="0.7em">reg</tspan></text>
		</>
	)
}

const Outer = () => {
	return (
		<>
			<USB />
			<SOL />
			<CLTS />
			<CSTS />
			<VSS1 />
			<CREG />
		</>
	)
}

export default Outer
